// Initialize Facebook Pixel and Google Analytics 4
// Run once on app startup

export function initializeAnalytics() {
  if (typeof window === 'undefined') return;

  // dataLayer must exist for gtag calls from tracker.ts
  window.dataLayer = window.dataLayer || [];

  const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID || 'GTM-NFK4DS6J';
  const GA_ID = process.env.NEXT_PUBLIC_GA4_ID || 'G-75WGH07LEB';
  const GOOGLE_ADS_ID = process.env.NEXT_PUBLIC_GOOGLE_ADS_ID;

  // ════════════════════════════════════════════════════════════════════════════
  // FACEBOOK PIXEL
  // ════════════════════════════════════════════════════════════════════════════

  const FB_PIXEL_ID = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID;

  // Load Facebook Pixel script only if a valid ID is provided
  if (FB_PIXEL_ID && FB_PIXEL_ID !== '1234567890123456') {
    const fbScript = document.createElement('script');
    fbScript.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${FB_PIXEL_ID}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(fbScript);
  }

  // Make fbq globally available
  window.fbq = (window as any).fbq || function (...args) {
    const pixel = window.fbq as any;
    if (pixel.callMethod) pixel.callMethod(...args);
    else pixel.queue.push(args);
  };
  (window.fbq as any).push = window.fbq;
  (window.fbq as any).loaded = true;
  (window.fbq as any).version = '2.0';
  (window.fbq as any).queue = [];

  // ════════════════════════════════════════════════════════════════════════════
  // EVENT MONITORING & DEBUGGING
  // ════════════════════════════════════════════════════════════════════════════

  // Log initialization in development
  if (process.env.NODE_ENV === 'development') {
    console.log(
      `[Analytics] Initialized:\n  GTM: ${GTM_ID}\n  GA4: ${GA_ID}\n  Google Ads: ${GOOGLE_ADS_ID || 'Not configured'}\n  Facebook Pixel: ${FB_PIXEL_ID}`
    );
  }
}

/**
 * Track user ID for cross-device tracking (call after login)
 */
export function setUserID(userId: string, email?: string) {
  if (typeof window === 'undefined') return;

  // Google Analytics — User-ID feature
  if (window.gtag) {
    window.gtag('config', {
      'user_id': userId,
    });
    window.gtag('event', 'login', {
      'user_id': userId,
      'user_email': email,
    });
  }

  // Facebook Pixel — User data for conversion API
  if (window.fbq) {
    window.fbq('track', 'CompleteRegistration', {
      'external_id': userId,
      'em': email ? hashEmail(email) : undefined,
    });
  }
}

/**
 * Hash email for Facebook Conversion API (SHA256)
 * This is sent alongside unhashed data — FB will match via both
 */
function hashEmail(email: string): string {
  if (typeof window === 'undefined') return '';

  // For client-side, we rely on Facebook SDK to hash
  // Just return the email; Facebook will hash it server-side for privacy
  return email.toLowerCase().trim();
}

/**
 * Retargeting pixel for abandoned carts (started but didn't complete)
 */
export function trackRetargetingAudience(audienceName: string) {
  if (typeof window === 'undefined' || !window.fbq) return;

  window.fbq('track', 'CustomEvent', {
    content_name: audienceName,
    audience_segment: 'retargeting',
  });
}
